import type { FC } from 'react';
import React from 'react';
import { SmartCaptcha } from '@yandex/smart-captcha';

import { useFormContext } from '../form/context';

type TProps = {
    onSuccess: (token: string) => void;
    onTokenExpired: () => void;
};

export const Captcha: FC<TProps> = ({ onSuccess, onTokenExpired }) => {
    const { setToken } = useFormContext();

    const handleSuccess = (token: string) => {
        onSuccess(token);
        setToken(token);
    };

    const handoleOnTokenExpired = () => {
        onTokenExpired();
        setToken(null);
    };

    return (
        <div style={{ height: 102 }}>
            <SmartCaptcha
                onSuccess={handleSuccess}
                onTokenExpired={handoleOnTokenExpired}
                sitekey={process.env.YANDEX_SMART_CAPTCHA_SITE_KEY || ''}
            />
        </div>
    );
};
